<template>
  <div class="min-h-screen bg-base-200 py-16 px-4 sm:px-6 lg:px-8">
    <div class="max-w-3xl mx-auto bg-base-100 p-8 md:p-12 rounded-3xl shadow-xl animate-fade-in-up">
      
      <h1 class="text-3xl md:text-4xl font-extrabold text-base-content mb-8 border-b border-base-200 pb-4">Cookie Policy</h1>
      
      <div class="space-y-6 text-base-content/80 leading-relaxed">
        
        <p>Aanza uses cookies to improve your interactive experience while browsing our digital menus and using our restaurant management dashboard.</p>
        
        <h2 class="text-xl font-bold text-primary mt-8 mb-2">What Are Cookies?</h2>
        <p>Cookies are small text files stored on your device that help us remember your preferences, such as your cart items when you scan a QR code, or your login session as a restaurant employee.</p>

        <h2 class="text-xl font-bold text-primary mt-8 mb-2">How We Use Them</h2>
        <ul class="list-disc list-inside space-y-2 ml-4">
          <li><strong>Essential:</strong> Keeping diners logged into their active table sessions and preserving cart states.</li>
          <li><strong>Performance:</strong> Understanding which food items get the most views on the digital menu.</li>
          <li><strong>Preferences:</strong> Remembering your theme choice (dark/light mode) or language preferences.</li>
        </ul>

        <h2 class="text-xl font-bold text-primary mt-8 mb-2">Managing Cookies</h2>
        <p>You can control or delete cookies through your browser settings. However, disabling essential cookies may break the QR ordering flow and cart functionality.</p>
      </div>

    </div>
  </div>
</template>

<style scoped>
.animate-fade-in-up {
  animation: fadeInUp 0.6s ease-out;
}
@keyframes fadeInUp {
  from { opacity: 0; transform: translateY(20px); }
  to { opacity: 1; transform: translateY(0); }
}
</style>
